import PropTypes from "prop-types";
import withRouter from "components/Common/withRouter";
import React from "react";
import {
    Container,
    Row,
    Col,
    Form,
    FormGroup,
    Input,
    Button,
    Label
} from "reactstrap";
import icon1 from "../../assets/images/logo1.png";
import iconlogo from "../../assets/images/logo2.png";

const PrivacyPolicyPage = (props) => {
    document.title = "Privacy Policy | Funnl";

    const currentDate = new Date();

    return (
        <div className="homepage-bg min-vh-100 d-flex flex-column">
            <Container className="">
                <div className="d-flex align-items-center home-top-icon-pos">
                    <img src={icon1} alt="logo" className="me-2" />
                    <span className="fw-medium fs-4 home-page-color">Funnl</span>
                </div>
                <div className="mt-5">
                    <div>
                        <h3>Privacy Policy&nbsp;</h3>
                    </div>
                    <div>
                        <p>SKai&nbsp;Solutions LLC DBA Ancile Services (&quot;Ancile Services,&quot; &quot;we,&quot; or &quot;us&quot;) is committed to protecting the privacy of its users. This Privacy Policy explains how we collect, use, and share your personal information in connection with your use of the&nbsp;Funnl&nbsp;app (the &quot;App&quot;). By accessing or using the App, you agree to the terms of this Privacy Policy.&nbsp;</p>
                    </div>
                    <div>
                        <p>Information We Collect&nbsp;</p>
                    </div>
                    <div>
                        <p>We may collect the following types of information when you use the App:&nbsp;</p>
                    </div>
                    <div>
                        <ul>
                            <li>
                                <p>Personal Information: We may collect information that can be used to identify you, such as your name, email address, and phone number.&nbsp;</p>
                            </li>
                        </ul>
                    </div>
                </div>
                <div>
                    <div>
                        <ul>
                            <li>
                                <p>Usage Information: We may collect information about how you use the App, including the features you use, the pages you visit, and the time and duration of your use.&nbsp;</p>
                            </li>
                            <li>
                                <p>Device Information: We may collect information about the device you use to access the App, including the device type, operating system, and unique device identifier.&nbsp;</p>
                            </li>
                            <li>
                                <p>Location Information: We may collect information about your location when you use the App, such as your city or ZIP code.&nbsp;</p>
                            </li>
                            <li>
                                <p>Other Information: We may collect other information that you provide to us when you use the App, such as feedback or comments.&nbsp;</p>
                            </li>
                        </ul>
                    </div>
                    <div>
                        <p>How We Use Your Information&nbsp;</p>
                    </div>
                </div>
                <div>
                    <div>
                        <p>We may use your information for the following purposes:&nbsp;</p>
                    </div>
                    <div>
                        <ul>
                            <li>
                                <p>To provide you with the App&apos;s services, features, and functionality.&nbsp;</p>
                            </li>
                            <li>
                                <p>To communicate with you about the App and respond to your inquiries.&nbsp;</p>
                            </li>
                            <li>
                                <p>To personalize and improve the App&apos;s services and features.&nbsp;</p>
                            </li>
                            <li>
                                <p>To&nbsp;analyze&nbsp;usage of the App and improve our products and services.&nbsp;</p>
                            </li>
                        </ul>
                    </div>
                </div>
                <div>
                    <div>
                        <ul>
                            <li>
                                <p>To comply with legal obligations and enforce our policies.&nbsp;</p>
                            </li>
                        </ul>
                    </div>
                    <div>
                        <p>How We Share Your Information&nbsp;</p>
                    </div>
                    <div>
                        <p>We may share your information with the following types of third parties:&nbsp;</p>
                    </div>
                    <div>
                        <ul>
                            <li>
                                <p>Service Providers: We may share your information with third-party service providers who perform services on our behalf, such as hosting, data analysis, and customer service.&nbsp;</p>
                            </li>
                            <li>
                                <p>Affiliates: We may share your information with our affiliates for the purposes described in this Privacy Policy.&nbsp;</p>
                            </li>
                        </ul>
                    </div>
                </div>
                <div>
                    <div>
                        <ul>
                            <li>
                                <p>Business Transfers: We may share your information in connection with a merger, acquisition, or sale of all or a portion of our assets.&nbsp;</p>
                            </li>
                            <li>
                                <p>Legal Requirements: We may disclose your information in response to a subpoena, court order, or other governmental request.&nbsp;</p>
                            </li>
                        </ul>
                    </div>
                    <div>
                        <p>Your Choices&nbsp;</p>
                    </div>
                    <div>
                        <p>You may choose to opt out of certain communications from us by following the instructions provided in the communication. You may also choose to delete your account and personal information by contacting us at the email address provided below.&nbsp;</p>
                    </div>
                    <div>
                        <p>Security&nbsp;</p>
                    </div>
                </div>
                <div>
                    <p>We take reasonable measures to protect your personal information from unauthorized access, disclosure, alteration, or destruction. However, no security system is perfect, and we cannot guarantee the security of your information.&nbsp;</p>
                </div>
                <div>
                    <p>Changes to this Privacy Policy&nbsp;</p>
                </div>
                <div>
                    <p>We may update this Privacy Policy from time to time. If we make material changes, we will notify you by email or by posting a notice in the App prior to the change becoming effective. Your continued use of the App after the effective date of the updated Privacy Policy constitutes your agreement to the updated Privacy Policy.&nbsp;</p>
                </div>
                <div>
                    <p>Contact Us&nbsp;</p>
                </div>
                <div>
                    <p>If you have any questions or comments about this Privacy Policy, please contact us at&nbsp;<a href="mailto:support@ancileservices.com" rel="noreferrer noopener" target="_blank">support@ancileservices.com</a>.&nbsp;</p>
                </div>

            </Container>

            {/* Footer */}
            <footer className="text-center py-3 small text-secondary fs-6 mt-auto">
                ©{currentDate?.getFullYear()} Powered by{" "}
                <a href="https://ancile.services" className="text-primary text-decoration-none" target="_blank" rel="noopener noreferrer">
                    Ancile Services
                </a>{" "}
                |{" "}
                <a href="/privacy-policy" className="text-primary text-decoration-none">
                    Privacy Policy
                </a>
            </footer>
        </div>
    );
};

export default withRouter(PrivacyPolicyPage);

PrivacyPolicyPage.propTypes = {
    history: PropTypes.object,
};
